import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSubmitNps() {
  const [isSaving, setSaving] = useState(false);

  const submit = useCallback((npsId, payload) => {
    setSaving(true);
    return quarkusApi
      .put(`/nps/${npsId}`, payload, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { submit, isSaving };
}
